import { render, staticRenderFns } from "./_trend_pop.vue?vue&type=template&id=43321506&scoped=true"
import script from "./_trend_pop.vue?vue&type=script&lang=js"
export * from "./_trend_pop.vue?vue&type=script&lang=js"
import style0 from "./_trend_pop.vue?vue&type=style&index=0&id=43321506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43321506",
  null
  
)

export default component.exports